import React, { Component } from 'react';
import i18n from '@i18next/i18n';
import { IItemData } from './item';
import Items from './items';
import Title from './title';
import style from './index.css';
interface IEditPanelProps {
    insertItemDatas: Array<IItemData>;
    addonItemDatas: Array<IItemData>;
}
export default class EditPanel extends Component<IEditPanelProps> {
    public constructor(props) {
        super(props);
        this.state = {
            textEditData: {
                editFontItemsData: [],
                editAlignItemsData: [],
                editItemNumberItemsData: [],
                editFontSize: [],
                editFontColor: {},
                editFillColor: {},
                editBorderColor: {},
            },
        };
    }
    public render() {
        const { insertItemDatas, addonItemDatas } = this.props;
        return <React.Fragment>
            <div className={style['insert-items']}>
                <Title title={i18n.t('插入')}/>
                <Items itemDatas={insertItemDatas} />
            </div>
            { addonItemDatas.length > 0
            && <div>
                <Title title={i18n.t('插件')}/>
                <Items itemDatas={addonItemDatas} />
            </div>}
        </React.Fragment>;
    }
}
